/* Suresh Peddavoora 10/30/2022 2698403495  Added client maintenance title in header  */

import React from 'react';
import LandingPage from '../../LandingPage';
import SearchOverview from './SearchOverview';

function ClientSearch() {
  return (
    <>
      <LandingPage showTabs={true} title={'Client Maintenance'}>
        <SearchOverview />
      </LandingPage>
    </>
  );
}

export default ClientSearch;
